!function(e) {
    let t = new Date,
    r = t.getFullYear(),
    i = t.getMonth() + 1,
    a = t.getDate(),
    o = new Date(r, i - 1, a),
    n = "___review_expiry",
    l = "__totalreviews",
    s = 0,
    g = 0,
    w = 0,
    v = 0,
    c = 0,
    u = 0,
    f = null;
    function p(e) {
        return e in  localStorage
    }
    function d(e) {
        return localStorage.getItem(e)
    }
    function h() {
        if (! (p(n) && p(l))) return !1; {
            let e = d(n),
            t = new Date(e);
            return ! (o < t) && !(o > t)
        }
    }
    function $() {
        if (e("#rio-dataprovider .cssVar-reviewStatistics").first().length && e("#rio-dataprovider .cssVar-reviewStatistics").eq(1).length) {
            let t = jQuery.parseJSON(f);
            v = parseFloat(t.google_review_count),
            w = parseFloat(t.google_rating),
            s = parseFloat(e("#rio-dataprovider .cssVar-reviewStatistics").first().text()),
            textValue = e("#rio-dataprovider .cssVar-reviewStatistics").eq(1).text().replace(/,/g, '');
             g = parseFloat(textValue);
            c = parseFloat(t.trustpilot_rating),
            u = parseFloat(t.trustpilot_review_count);
            let r = v + g + u,
            i = (w + s + c) / 3,
            a = Math.round(10 * i) / 10;
            if (null != r) {
                e("#global-review-count-target").text(r),
                e(".footer-review-widget #global-review-count-target").text(r),
                e(".review-collection-page #global-review-count-target").text(r),
                e("#global-review-rating-target").text(a),
                e(".footer-review-widget #global-review-rating-target").text(a),
                e(".review-collection-page #global-review-rating-target").text(a);
                var o = e(".review-collection-page .Stars");
                0 != o.length && o.attr("style", "--review-star-rating:" + a);
                var n = e(".footer-review-widget .Stars");
                0 != n.length && n.attr("style", "--review-star-rating:" + a);
                var l = e(".global-reviews .Stars");
                0 != l.length && l.attr("style", "--review-star-rating:" + a)
            }
        } else setTimeout($, 50)
    }
    h() ? (f = d(l), jQuery(document).ready($)) : fetch("https://demo.saffronalley.com/sa/api.php/reviews/list").then(e => {
        if (!e.ok) throw Error("Network response was not ok");
        return e.json()
    }).then(e => {
        var t, r;
        t = e,
        console.log("API CALLED"),
        r = JSON.stringify(t),
        localStorage.setItem("___review_expiry", o),
        localStorage.setItem("__totalreviews", r),
        h() && (f = d(l), jQuery(document).ready($))
    }).
    catch(e => {
        console.log(e.message)
    })
} (jQuery);